const Telegram = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13612_122887)">
      <rect width="40" height="40" fill="#25A3E1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.487 18.7602C16.3154 16.229 20.1955 14.547 22.1439 13.7311C27.6893 11.4163 28.855 11.0167 29.6044 11C29.7709 11 30.1372 11.0333 30.387 11.2331C30.5869 11.3997 30.6368 11.6162 30.6701 11.7827C30.7034 11.9492 30.7367 12.2989 30.7034 12.5654C30.4037 15.7294 29.1048 23.4063 28.4387 26.9367C28.1556 28.4355 27.606 28.9351 27.0731 28.985C25.9074 29.0849 25.0248 28.219 23.9091 27.4863C22.1439 26.3372 21.1614 25.6211 19.4461 24.4888C17.4645 23.1898 18.7467 22.4738 19.8791 21.3081C20.1789 21.0083 25.2913 16.3455 25.3912 15.9292C25.4078 15.8793 25.4078 15.6794 25.2913 15.5795C25.1747 15.4796 25.0082 15.5129 24.875 15.5462C24.6918 15.5795 21.8941 17.4446 16.4486 21.1249C15.6493 21.6744 14.9332 21.9409 14.2838 21.9242C13.5677 21.9076 12.2022 21.5246 11.1697 21.1915C9.92076 20.7918 8.92159 20.5754 9.00485 19.8759C9.05481 19.5096 9.55439 19.1432 10.487 18.7602Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13612_122887">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { Telegram };
